import type { FaireProductEntity } from "../../entity_types/product";

export const p_nnmtk8amkk: FaireProductEntity = {
  token: "p_nnmtk8amkk",
  type: "product",
  name: "Momma's Kitchen - Soy Candle",
  brandToken: "b_6819yojpbc",
  brandName: "Antique Candle Co.®",
  imageUrl:
    "https://cdn.faire.com/fastly/55b3a055db182ef56d0d868598f6333a7e36f68a1750767b8a15adb59bd8cd62.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/78c71a2a905d1fbe7bc8898acfc4b07f1dd4b2a77feadefb964a36c2cc23e536.jpeg",
    "https://cdn.faire.com/fastly/19db77df523b8ac34380a8d77fc428176965bc4e3c0ba6e7273cf3b884f7b652.png",
    "https://cdn.faire.com/fastly/5b668ffcc294e14de770a60e4291a5528e81f82007efa473b61ad52cd354b028.png",
    "https://cdn.faire.com/fastly/720c37da069333f657c6f834461ac1b784d2b1d94b822b822f2386e86ab0dfb3.png",
  ],
  priceDollars: 204,
  description:
    "Momma's Kitchen has a proven high-sell through rate in stores that stock it across the U.S! It is a continued best-seller that stores are consistently restocking! The perfect candle any time of year.\n\nIt is a warm and cozy blend of green apples, bright peach, and fresh pine, highlighted with a heart of cinnamon and notes of sweet balsamic spice.\n\nMade in Lafayette, Indiana with domestically grown, natural soy wax for a clean, long-lasting, and even burn. We use premium fragrance oils (approved by thousands of candle testers across the U.S.!) and 100% lead-free cotton wicks.\n\nAll candles are paraffin-free, dye-free, and cruelty-free. This hand-picked fragrance is phthalate and paraben-free.\n\n𝟏𝟔 𝐨𝐳 𝐂𝐚𝐧𝐝𝐥𝐞:\n• RRP: $38.00\n• Approximate burn time: 60 hours\n• UPC: 840174200666",
  tags: [],
  msrpDollars: 456,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:54.357Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
